import styled, { css, keyframes } from "styled-components";
import { IndicatorLayout } from "../consts/indicator-layout";
import {styledByTheme} from "../../../themes/architecture/styled-by-theme";

const pulseAnimation = keyframes`
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(0.8);
    }
    100% {
        transform: scale(1);
    }
`;

const IndicatorBadgeDefaultBox = styled.div<{displayLayout?: IndicatorLayout}>`
    position: absolute;
    line-height: 1;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    top: ${({displayLayout}) => displayLayout === IndicatorLayout.List ? "50%" : "0.5rem" };
    right: ${({displayLayout}) => displayLayout === IndicatorLayout.List ? "0" : "0.5rem" };
    width: ${({displayLayout}) => displayLayout === IndicatorLayout.List ? "auto" : "2rem" };
    height: ${({displayLayout}) => displayLayout === IndicatorLayout.List ? "auto" : "2rem" };
    font-size: 1rem;
    color: ${({theme}) => theme.components.header.colors.indicatorBadge.text};
    background: ${({displayLayout, theme}) =>
        displayLayout === IndicatorLayout.List ?
            theme.components.header.colors.indicatorBadge.backgroundInListLayout :
            theme.components.header.colors.indicatorBadge.backgroundInGridLayout
    };
    border-radius: ${({displayLayout}) => displayLayout === IndicatorLayout.List ? "5px" : "50%" };
    padding: ${({displayLayout}) => displayLayout === IndicatorLayout.List ? "0.65rem 1rem" : "0" };
    ${({displayLayout}) => displayLayout === IndicatorLayout.List ? css`
        transform: translateY(-50%);
    ` : css`
        animation: ${pulseAnimation} 2s ease 1s infinite;
    `}
`;

const IndicatorBadgeSIBox = styled(IndicatorBadgeDefaultBox)`
    top: -0.4rem;
    right: -1rem;
`;

export const IndicatorBadgeBox = styledByTheme(IndicatorBadgeDefaultBox)
    .forSI(IndicatorBadgeSIBox)
    .apply();
